import React from "react";
import PropTypes from "prop-types";
import clearButtonUrl from "remove-button.svg";
import styles from "components/common/text-field.scss";

export const TextField = ({ disabled, onChange, onClear, placeholder, type, value }) => (
  <div className={ styles.container }>
    <input
      className={ classNames(onClear) }
      disabled={ disabled }
      onChange={ (e) => onChange(e.target.value) }
      placeholder={ placeholder }
      type={ type }
      value={ value }
    />
    { (onClear && value.length > 0) ? renderClearButton(onClear) : null }
  </div>
);

TextField.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired, // (string) => void
  onClear: PropTypes.func, // () => void
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string.isRequired
};

TextField.defaultProps = {
  disabled: false,
  onClear: undefined,
  placeholder: null,
  type: "text"
};

const classNames = (onClear) => {
  if (onClear) {
    return `${styles.input} ${styles["input--clearable"]}`;
  }
  return styles.input;
};

const renderClearButton = (onClear) => (
  <img
    alt="Clear"
    className={ styles["clear-button"] }
    height={ 16 }
    onClick={ onClear }
    src={ clearButtonUrl }
    width={ 16 }
  />
);



// WEBPACK FOOTER //
// ./src/js/components/common/text-field.jsx